import { name as vCookiePolicy } from '@/views/cookie-policy/cookie-policy.route';
import { RouteParams }           from '@/router/router.types';

export default () => {
  const cookiePolicy: RouteParams = {
    to: {
      name: vCookiePolicy,
    },
  };

  return {
    cookiePolicy,
  };
};
